import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import Feature from "./Feature/Feature";
import classes from "./Features.module.css";
interface IParentProps {
  featuresList: string[];
  t: any;
}
type Props = IParentProps & RouteComponentProps;
class Features extends Component<Props> {
  render() {
    let { t } = this.props;
    console.log("features list", this.props.featuresList);
    let features: any;
    if (this.props.featuresList)
      features = this.props.featuresList.map((feature) => {
        if (feature.toLowerCase() === "find provider") {
          return (
            <li key="find-provider">
              <Feature
                group="find.svg"
                name={t("homePage.findProvider")}
                path="find-provider"
              />
            </li>
          );
        } else if (feature.toLowerCase() === "balance billing") {
          return (
            <li key="balance-billing-newupload">
              <Feature
                group="dollar.svg"
                name={t("homePage.balanceBilling")}
                path="balance-billing-newupload"
              />
            </li>
          );
        } else if (feature.toLowerCase() === "procedure shopper") {
          return (
            <li key="procedure-shopper">
              <Feature
                group="trolley.svg"
                name={t("homePage.procedureShopper")}
                path="procedure-shopper"
              />
            </li>
          );
        } else if (feature.toLowerCase() === "telemedicine") {
          return (
            <li key="telemedicine">
              <Feature group="doctor.svg" name={feature} path="telemedicine" />
            </li>
          );
        } else if (feature.toLowerCase() === "my favorites") {
          return (
            <li key="my-favorites">
              <Feature
                group="heart.svg"
                name={t("homePage.myFavorite")}
                path="my-favorites"
              />
            </li>
          );
        } else if (feature.toLowerCase() === "prescriptions") {
          return (
            <li key="prescriptions">
              <Feature group="bottle.svg" name={feature} path="prescriptions" />
            </li>
          );
        } else if (feature.toLowerCase() === "id card") {
          return (
            <li key="idcard">
              <Feature group="menu-idcard.svg" name={feature} path="idcard" />
            </li>
          );
        } else if (feature.toLowerCase() === "pharmacy") {
          return (
            <li key="drexi">
              <Feature
                group="bottle.svg"
                name={t("homePage.pharmacy")}
                path="pharmacy"
              />
            </li>
          );
        } else {
          return (
            <li key="prescriptions">
              <Feature group="bottle.svg" name={feature} path="prescriptions" />
            </li>
          );
        }
      });

    return (
      <div className={classes.featuredList}>
        <ul>{features}</ul>
      </div>
    );
  }
}

export default withRouter(Features);
